import userStore from "@/store/userStore";
import axios, { AxiosRequestConfig } from "axios";

export function configureCouncilHeaderInterceptor() {
  axios.interceptors.request.use((axiosConfig: AxiosRequestConfig) => {
    const council = userStore.activeCouncil;
    if (!council || council === "") {
      throw new Error("Council has not been set");
    }
    axiosConfig.headers.Council = council;

    return axiosConfig;
  });
}
